import React from 'react';
import classnames from 'classnames';

import * as styles from './style.module.scss';

import { Formik, Form } from 'formik';
import { Link } from 'gatsby';

import Input from 'components/UI/InputFormik';
import Checkbox from 'components/UI/Checkbox';
import Button from 'components/UI/Button';
import Icon from 'components/UI/Icon';
import validationSchema from './validationSchema';

import useGravityForm from 'hooks/useGravityForm';

const RegistrationForm = ({ data }) => {
  const submitGravityForm = useGravityForm(1);

  return (
    <Formik
      initialValues={{
        name: '',
        companyName: '',
        phone: '',
        email: '',
        accept: false,
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        submitGravityForm(values)
          .then(({ confirmation_message }) => {
            console.info(confirmation_message);
          })
          .catch((err) => {
            console.error(err.response);
          });

        setSubmitting(false);
      }}
    >
      <Form noValidate>
        <ul className={styles.form_inputs}>
          <li>
            <Input
              name="name"
              type="text"
              placeholder={data.inputs.name || 'Name'}
            />
          </li>
          <li>
            <Input
              name="companyName"
              type="text"
              placeholder={data.inputs.company || 'Company'}
            />
          </li>
          <li>
            <Input
              name="phone"
              type="tel"
              placeholder={data.inputs.phone || 'Phone'}
            />
          </li>
          <li>
            <Input
              name="email"
              type="email"
              placeholder={data.inputs.email || 'Email'}
            />
          </li>
        </ul>

        <div className={styles.form_submit}>
          <Checkbox name="accept" className={styles.form_submit_accept}>
            {data.checkboxLabel}
            <Link
              to={data.checkboxLabelHighlighted.link || '#'}
              className={'cr-link cr-main'}
            >
              &nbsp;{data.checkboxLabelHighlighted.text}
            </Link>
          </Checkbox>

          <Button
            type="submit"
            className={classnames(
              'cr-btn--icon cr-btn--large cr-btn--icon-red-bg',
              styles.form_submit_btn
            )}
          >
            {data.btnTxt || 'Submit'}
            <Icon name="corner-arrow-small-bold" />
          </Button>
        </div>
      </Form>
    </Formik>
  );
};

export default RegistrationForm;
